<script lang="ts" setup>
  import { useMyStore } from "~/stores/myStore"  
  const myStore = useMyStore()

	const corMarcaAzul  = '#176096'
	const corMarcaVerde = '#189370'
	const corMarcaCinza = '#606060'
	const corPerfil = '#FFFFFF'

	//const corPerfil = computed(() => ehAdministrador ? '#330000' : ehPesquisador ? '#00004d' : ehRespondente ? '#333300' : '#545c64')

	const formAjuda = reactive({
		visivel: false,
		esconder: () => {
			formAjuda.visivel = false
		}
	})

	const exibirAjuda = () => {
		formAjuda.visivel = true
	}

	const estaLogado = () => {
		return utilLogin.estaLogado()
	}

	const ehRespondente = () => {
		return myStore.dadosLogin?.Perfil == 'Respondente'
	}


</script>

<template>
	<div>
		<el-menu
		mode="horizontal"
		:background-color="corPerfil"
		text-color="#fff"
		active-text-color="#fff"
		:ellipsis="false"
		>
		<el-menu-item index="0">
			<img src="/logo/logo-questnova-prancheta-1.png" class="logo-principal">
		</el-menu-item>
		
		<!--alinhamento à direita-->
		<div class="flex-grow" />
		
		<el-menu-item index="1" class="icone-menu-superior" v-if="estaLogado() && !ehRespondente()">
			<NuxtLink class="link-menu" to="/">
				<!--<Icon name="mdi:home" size="40px"/>-->
				<img src="/icones/icones-questnova-home.png" class="cor-azul icone-menu">
			</NuxtLink>
		</el-menu-item>
		
		<el-menu-item index="2" class="icone-menu-superior" v-on:click="exibirAjuda" v-if="estaLogado() && !ehRespondente()">
			<NuxtLink class="link-menu">
				<!--<Icon name="material-symbols:help" size="40px"/>-->
				<img src="/icones/icones-questnova-duvida.png" class="cor-azul icone-menu">
			</NuxtLink>
		</el-menu-item>
		
		<el-menu-item index="3" class="icone-menu-superior" v-on:click="utilLogin.sairDaConta()" v-if="estaLogado() && !ehRespondente()">
			<NuxtLink class="link-menu">
				<!--<Icon name="mingcute:exit-door-fill" size="40px"/>-->
				<img src="/icones/icones-questnova-sair-01.png" class="cor-azul icone-menu">
			</NuxtLink>
		</el-menu-item>
		
	</el-menu>

	<!--form-ajuda-->
	<el-dialog v-model="formAjuda.visivel" :before-close="formAjuda.esconder" draggable :fullscreen="false" width="80%">
		<template #header>
			<div class="titulo-pagina">
				Ajuda
			</div>     
		</template>
		<p>
			<b>Bem-vindo ao nosso sistema de pesquisa online!</b>
		</p>
		<p>
			Estamos felizes por você escolher nossa plataforma para realizar suas pesquisas.</p>
		<p>
			Nosso objetivo é tornar o processo de pesquisa o mais fácil e eficiente possível.
		</p>
		<p>
			Acesse nosso site, onde você encontrará informações úteis para navegar e utilizar nosso sistema com sucesso:
		</p>
		<p>
			<b>Site: <el-link type="primary" href="https://www.fsp.usp.br/nupens/" target="_blank">https://www.fsp.usp.br/nupens/</el-link></b><br>
			<b>Canal do Youtube: <el-link type="primary" href="https://www.youtube.com/@NupensUSP" target="_blank">https://www.youtube.com/@NupensUSP</el-link></b><br>
			<b>Vídeos de instrução (playlist): <el-link type="primary" href="https://www.youtube.com/playlist?list=PL-x9893LI0GQZPxntj4t6wJw06VB7IgNz" target="_blank">https://www.youtube.com/playlist?list=PL-x9893LI0GQZPxntj4t6wJw06VB7IgNz</el-link></b>
		</p>
		<p>
			Para mais informações, entre em contato:<br>
			<br>
			<b>NUPENS - Núcleo de Pesquisas Epidemiológicas em Nutrição e Saúde, Universidade de São Paulo</b><br>
			<br>
			Faculdade de Saúde Pública<br>
			Av. Dr. Arnaldo, 715 - São Paulo - SP<br>
			CEP: 01246-90<br>
			<br>
			E-mail: <a href="mailto:questnova@fsp.usp.br">questnova@fsp.usp.br</a>
			<br><br>
		</p>
		<hr>
		<p>
			<b>EQUIPE:</b><br>
			<br>
			<b>Coordenação</b><br>
			Maria Laura Louzada<br>
			<br>
			<b>Pesquisadores</b><br>
			Evelyn Frade<br>
			Kamila Gabe<br>
			Thays Nascimento Souza<br>
			Carlos Augusto Monteiro<br>
			Caroline Costa<br>
			Daniela Neri<br>
			Eurídice Martínez<br>
			Fernanda Helena Marrocos Leite<br>
			Fernanda Rauber<br>
			Francine Santos<br>
			Neha Khandpur<br>
			Renata Bertazzi Levy<br>
			<br>
			<b>Apoio técnico</b><br>
			Gustavo Akinaga Patrício<br>
			<br>
			<b>Desenvolvimento</b><br>
			<el-link type="primary" href="https://softjads.com.br" target="_blank">Softjads.com.br - Desenvolvimento de Sistema para Pesquisas</el-link><br>
		</p>
		<div style="float: right">
			<img src="/logo/logo-nupens.png" class="icone-botao">
		</div>
		<br><br>
	</el-dialog>
</div>
</template>

<style scope>
.flex-grow {
	flex-grow: 1;
}
.link-menu {
	color: white;
	text-decoration: none;
}
.icone-menu-superior {
	height: 80px !important;
	width: 60px;
	margin-right: 10px !important;
}
</style>